import React from "react";
import { NavLink } from "react-router-dom";
import KnoaCardMainRow from '../CardParts/KnoaCardMainRow';

const LinkCard = ({ icon, subHeading, heading, path, footerText }) => {
    const cardContent = (
        <div className="card shadow-sm mb-3">
            <div className="card-body px-4">
                <KnoaCardMainRow
                    icon={icon}
                    subHeading={subHeading}
                    heading={heading}
                />
            </div>

            {footerText && (
                <div className="px-4 pb-3">
                    <hr className="mt-0 mb-2" />
                    <div
                        className="d-flex align-items-center"
                        style={{ minHeight: "48px" }}
                    >
                        <span className="text-muted small">{footerText}</span>
                    </div>
                </div>
            )}
        </div>
    );

    const hasValidPath = path?.heading && path?.subHeading;

    return hasValidPath ? (
        <NavLink
            to={`/admin/${path.subHeading.replace(/ /g, "")}/${path.heading.replace(/ /g, "")}`}
            className="nav-link"
        >
            {cardContent}
        </NavLink>
    ) : (
        cardContent
    );
};

export default LinkCard;